/*
  The page heading, and the gilded rule that sits under it.

  This is the mockup's `.m-hero` — the block holding the page's own h1 — and not the
  cert-lookup photo band, which the codebase also calls a hero but which the mockup does
  not model at all. Gilded centres this block and draws a short gilded rule beneath it;
  navy leaves both exactly as they were.

  Two exports rather than one wrapper component, because the five views do not agree on
  what surrounds their h1 — one has a logo instead of visible text, one has a subtitle,
  three have nothing — and a wrapper would have had to grow a prop per view.
*/

import React from "react";

/*
  Goes on the <h1> itself (or on the block that holds it, where there is one). Inert in
  navy: nothing selects `skin-page-heading` without [data-skin='gilded'].
*/
export const PAGE_HEADING = "skin-page-heading";

/*
  The rule. `hidden` by default and lifted to `display: block` only under gilded, so navy
  renders nothing at all rather than an element with zero height.

  A <span>, aria-hidden, rather than an <hr>: it is decoration under a heading, not a
  thematic break between sections, and an <hr> here would land in the accessibility tree
  and in the document outline.
*/
export const PageHeadingRule = () => (
  <span aria-hidden="true" className="skin-page-heading-rule hidden" />
);
